import { AutogenLayoutOfficeTimecardHistoryList } from "./autogen/AutogenLayoutOfficeTimecardHistoryList";

export class OfficeTimecardHistoryList extends AutogenLayoutOfficeTimecardHistoryList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "payee_id", sort: "asc" }];
    }
}
